export const idleCostField = "Idle Capacity Cost";
export const idleCostInfoTooltipTitle = "Unused compute cost";
